document.addEventListener("DOMContentLoaded", () => {

    function convertTZ(date, tzString) {
      return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));   
  }
    

  

    
    var hh;
    var ll;
    
    var mm = "";
    var dd = "";
    var yy = "";
    var hh = "";
    var mmm = "";
    var ss = "";


    var dText ="";
    var hText = "";
    var mText = "";
    var sText = "";
  
    var tottalDate;
    var countDownDate;
    
    var totalDateCtach = [];
    
    var now = 0;
    
    var timeleft = 0;
    
    var days = 0;
    var hours = 0;
    var minutes = 0;
    var seconds = 0;
    
    var highlightedItems = "";
    

    

      mm = $('.countdown').attr('data-mm');
      dd = $('.countdown').attr('data-dd');
      yy = $('.countdown').attr('data-yy');
      hh = $('.countdown').attr('data-hh');
      mmm = $('.countdown').attr('data-mmm');
      ss = $('.countdown').attr('data-ss');



     var dText = $('.countdown').attr('data-ddtext');
     var hText = $('.countdown').attr('data-hhtext');
     var mText = $('.countdown').attr('data-mmtext');
     var sText = $('.countdown').attr('data-sstext');


      
    
      tottalDate = mm+" "+dd+","+" "+yy+" "+hh+":"+mmm+":"+ss;
      totalDateCtach.push(tottalDate);
       
      

    

    
    
    
    
    
    
    
    
    
        var myfunc = setInterval(function() {
        countDownDate = new Date(totalDateCtach).getTime();
  
          
        now = new Date();
        hh = convertTZ(now,"Europe/London");
        ll = hh.getTime();  
  
        timeleft = countDownDate - ll;  
  
            
        days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
        hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
        seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
  
     
          
        highlightedItems = $(".countdown");
    
        if(highlightedItems.hasClass("isfinish")){
          highlightedItems.css('visibility','hidden');
        }
    
            if(days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0){
                clearInterval();
                highlightedItems.html("<div class='dateMe me'>0<span>"+dText+"</span></div><div class='dateMe me'>0<span>"+hText+"</span></div><div class='dateMe me'>0<span>"+mText+"</span></div><div class='dateMe me'>0<span>"+sText+"</span></div>");
           }else{    
            highlightedItems.html("<div class='dateMe me'>"+parseInt(days)+"<span>"+dText+"</span></div><div class='dateMe me'>"+parseInt(hours)+"<span>"+hText+"</span></div><div class='dateMe me'>"+parseInt(minutes)+"<span>"+mText+"</span></div><div class='dateMe me'>"+parseInt(seconds)+"<span>"+sText+"</span></div>");
        }
 
    
        }, 1000);
        
    
    });
    
    
    /*final count down*/
    